module.exports = __webpack_public_path__ + "media/images/favicon-21336c25a43d313ae88a7c16f7ba55f6.svg";